import { renderCustomColumnDefs } from "../../../../../shared/Table/table.utils";
import { capitalizeAll, renderAmount } from "../../../../../utils";

// Config for table and form
const tableConfig = [
  // {
  //   Header: "#",
  //   accessor: "",
  //   Cell: (row) => {
  //     return row.row.id * 1 + 1;
  //   },
  //   // disableSortBy: true,
  //   // disableFilters: true,
  // },
  {
    id: "appointment",
    header: "Transaction",
    // cell: ({ getValue }) => formatDate(getValue()?.date),
    // size: 120,
    columns: [],
  },
  {
    header: "Order Number",
    id: "orderNumber",
    minSize: 120,
    cell: ({ getValue }) => getValue(),
  },
  {
    header: "Driver",
    id: "driver",
    minSize: 100,
    cell: ({ getValue }) => {
      return getValue()?.firstName;
      return capitalizeAll(getValue()?.firstName);
    },
  },
  {
    header: "Load Type",
    id: "loadType",
    width: 120,
    cell: ({ getValue }) => getValue(),
  },
  {
    header: "Weight",
    id: "weight",
    cell: ({ getValue }) => {
      return `${getValue()?.toLocaleString("en-US")} lbs`;
    },
    minSize: 120,
    size: 90,
  },
  {
    header: "Base Charge",
    id: "baseCharge",
    cell: ({ getValue }) => renderAmount(getValue()),
    size: 120,
  },
  {
    header: "Drop Charge",
    id: "dropCharge",
    cell: ({ getValue }) => renderAmount(getValue()),
    size: 120,
  },
  {
    header: "StandBy Time",
    id: "waitTime",
    minSize: 110,
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "";
      return `${value?.total} hrs`;
    },
  },
  {
    header: "Other Charges",
    id: "otherCharges",
    cell: ({ getValue }) => renderAmount(getValue()),
    minSize: 110,
  },
  {
    header: "Fuel Surcharge",
    id: "fuelSurcharge",
    cell: ({ getValue }) => renderAmount(getValue()),
    minSize: 120,
  },
  {
    header: "Total Charges",
    id: "totalCharges",
    cell: ({ getValue }) => renderAmount(getValue()),
    minSize: 130,
  },
  { id: "legs", visible: false },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
